<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { computed, ref } from 'vue';
  import { useActiveElement } from '@vueuse/core';

  const { locale, locales, setLocale } = useI18n();

  const availableLocales = computed(() => {
    return locales.value.filter((i) => i.code !== locale.value);
  });

  const isOpen = ref(false);

  const showMenu = () => {
    isOpen.value = true;
  };

  const hideMenu = () => {
    isOpen.value = false;
  };

  const toggleMenu = () => {
    if (isOpen.value) hideMenu();
    else showMenu();
  };

  const hideMenuOnBlur = () => {
    const activeElement = useActiveElement();

    if (
      !activeElement.value ||
      activeElement.value.classList.contains('locale-selector') ||
      activeElement.value.classList.contains('locale-selector__item')
    ) {
      return;
    }

    hideMenu();
  };

  const navigateToLocale = async (loc: string) => {
    hideMenu();
    await setLocale(loc);
  };
</script>

<template>
  <div
    :class="['locale-selector', { 'locale-selector--open': isOpen }]"
    tabindex="0"
    @click="toggleMenu"
    @blur="hideMenuOnBlur">
    <span class="locale-selector__text">{{ locale }}</span>
    <span class="locale-selector__chevron" />
    <div class="locale-selector__dropdown">
      <a
        v-for="loc in availableLocales"
        :key="loc.code"
        class="locale-selector__item"
        tabindex="0"
        @click.prevent.stop="navigateToLocale(loc.code)"
        @focus="showMenu"
        @blur="hideMenuOnBlur">
        {{ loc.code }}
      </a>
    </div>
  </div>
</template>
